import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

import { useKbOverview } from "../api";

/** Sentinel for "no filter" — Radix Select forbids an empty-string item value. */
const ANY = "__any__";

/**
 * Category picker shared by Articles, Search and Ask. Options come from the
 * same facet the Overview renders, so it can only offer categories that
 * actually exist in the index.
 */
export function CategorySelect({
  value,
  onChange,
  disabled,
  className = "w-56",
}: {
  value?: string;
  onChange: (next: string | undefined) => void;
  disabled?: boolean;
  className?: string;
}) {
  const { data } = useKbOverview();
  const categories = (data?.categories ?? []).filter(
    (c) => c.value.trim() !== "",
  );
  return (
    <Select
      value={value ?? ANY}
      onValueChange={(v) => onChange(v === ANY ? undefined : v)}
      disabled={disabled}
    >
      <SelectTrigger className={className}>
        <SelectValue placeholder="All categories" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={ANY}>All categories</SelectItem>
        {categories.map((c) => (
          <SelectItem key={c.value} value={c.value}>
            {c.value}
            <span className="ml-2 text-xs text-muted-foreground">
              {c.count}
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
